import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forceRelogin } from './actions';
import { exhaustMap, map, take } from 'rxjs';
import { ReloginDialogComponent } from '../shared/dialogs/relogin-dialog/relogin-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginServiceState } from '../services/login-service/state/login-service.state';
import { Store } from '@ngrx/store';
import { logout } from '../services/login-service/state/login-service.actions';

@Injectable()
export class AppEffects {
  private readonly actions$ = inject(Actions);
  private readonly loginServiceStore = inject<Store<LoginServiceState>>(Store);
  private readonly dialog = inject(MatDialog);

  forceRelogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(forceRelogin),
        exhaustMap(() => {
          // Remove user from localStorage so that user is still logged out if
          // the user closes the browser tab and reopen RAIN / navigates away
          // while the dialog is open
          localStorage.removeItem('user');
          const dialogRef = this.dialog.open(ReloginDialogComponent, {
            disableClose: true,
          });
          return dialogRef.afterClosed().pipe(
            take(1),
            map(() => {
              this.loginServiceStore.dispatch(logout());
            })
          );
        })
      ),
    { dispatch: false }
  );
}
